import { auth } from './firebase';

async function fetchWithToken(url, options = {}) {
    const token = await getUpdatedToken();
    const headers = new Headers(options.headers || {});
    headers.set('Authorization', `Bearer ${token}`);

    const updatedOptions = {
        ...options,
        headers,
    };

    return fetch(url, updatedOptions);
}

async function getUpdatedToken() {
    return new Promise((resolve, reject) => {
        const user = auth.currentUser;
        if (user) {
            user.getIdToken().then((token) => {
                resolve(token);
            });
        } else {
            reject('No user found');
        }
    });
}

export default fetchWithToken;
